import { defineStore } from "pinia";
import { ref } from "vue";
import {
  TUTORIAL_VIDEOS,
  tutorialById,
  type TutorialVideo,
} from "../../config/tutorials";
import { trackTutorialEvent } from "../../helpers/tutorialAnalytics";

/**
 * One tutorial dialog for the whole app (mounted in App.vue).
 * Any surface — Welcome page, practice list, coach marks — asks this store
 * to open with a list of clips.
 */
export const useTutorialStore = defineStore("tutorial", () => {
  const open = ref(false);
  const videos = ref<TutorialVideo[]>([]);

  function openTutorials(list: TutorialVideo[]) {
    if (!list.length) return;
    videos.value = list;
    open.value = true;
    for (const video of list) {
      trackTutorialEvent("tutorial_open", { videoId: video.id });
    }
  }

  function openAll() {
    openTutorials(TUTORIAL_VIDEOS);
  }

  function openTutorial(id: string) {
    const video = tutorialById(id);
    if (video) openTutorials([video]);
  }

  function close() {
    open.value = false;
  }

  return { open, videos, openTutorials, openAll, openTutorial, close };
});
